export const randomId = (length = 10) =>
  [...Array(length)].map(() => Math.random().toString(36)[2]).join('');
